import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { ContentWrapper, PageHeader } from '../../styled-components/shared';
import Search from '../../components/Search';
import { Button, Table, Icon } from '@zebra-fed/zds-react-desktop';
import { useHistory } from 'react-router-dom';
import '@zebra-fed/icons/General/index.css';
import '@zebra-fed/icons/Zebra-Accessories/index.css';
import '@zebra-fed/icons/Navigation/index.css';
import {useTranslation} from "react-i18next";

const Header = styled.div`
    display: flex;
    flex-direction: row;
    height: 40px;
    font-size: 20px;
    color: #4c4c4c;
    align-items: start;
    padding: 0 16px;
`

const SearchContainer = styled.div`
    border-bottom: 1px solid #D7D7D7;
    display: flex;
    margin-left: auto;
    height: 22px;
`

const MainContent = styled.div`
    border-top: 1px solid #E1E1E1;
`

const StyledHeader = styled(PageHeader)`
    justify-content: space-between;
    min-width: 1020px;
`

const ButtonContainer = styled.div`
    display: flex;
    margin-left: 20px;
    transition: all 0.3s;
`

export default function ManageUsersPage(props) {
    /*const [data, setDataVal] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [hoveredItem, setHoveredItem] = useState(null);
    const [searchVal, setSearchVal] = useState('');
    const [searchResults, setSearchResults] = useState([])*/
    //NOTE:  all the set methods of the useState have been removed to avoid the lint issues.

    const [data] = useState([]);
    const [selectedItems] = useState([]);
    const [hoveredItem] = useState(null);
    const [searchVal] = useState('');

    const history = useHistory();
    const {t} = useTranslation()

    useEffect(() => {
        //setData();
    }, [])

    useEffect(() => {
        // const results = data.filter(item => {
        //     return Object.keys(item).map((key) => {
        //         return item[key] && item[key].includes(searchVal)
        //     }).includes(true);
        // })
        // setSearchResults(results)
    }, [searchVal])


    function onDeleteClicked() {
        const ids = selectedItems.map(index => {
            return data[index].UUID
        })
    }

    function onPrintClicked() {
        let badgeData = selectedItems.map(index => {
            const item = data[index];
            return {
                id: item.UUID,
                un: `${item.firstName} ${item.lastName}`
            }
        })
        history.push({
            pathname: '/printbatch',
            search: `?data=${JSON.stringify(badgeData)}`
        })
    }

    function onDeleteIconClicked() {
    }

    function onPrintIconClicked() {
        history.push(`/print?un=${data[hoveredItem].UUID}`)
    }

    const tableHeaders = [
        {name: t('modelNumber'), style: {color: '#007ABA', minWidth: 200}, columnStyle: {minWidth: 200, color: '#007ABA'}},
        {name: t('serialNUmber')},
        {name: t('siteNumber')},
    ]

    const sampleData = [{modelNo: 'TC75', serialNo: "204085225D0317", siteName: "MOD Device"}]

    const searchStyle = { width: 190, height: 22, fontSize: '13px', display: 'flex', margin: 0, border: 'none'};
    const buttonStyle = { margin: '0 4px', fontSize: '14px' };

    const tableActions = [
        <Icon 
            category={'general'}
            name={'print'}
            size={18}
            color={'#007ABA'}
            style={{marginLeft: 128, marginRight: 20, cursor: 'pointer'}}
            onClick={onPrintIconClicked}
        />,
        <Icon 
            category={'zebra-accessories'}
            name={'pen'}
            size={18}
            color={'#007ABA'}
            style={{margin: '0 12px 0 20px', cursor: 'pointer'}}
        />,                    
        <Icon
            name={'cancel'}
            category={'navigation'}
            color="#8e8e8e"
            size={18}
            style={{margin: '0 20px', cursor: 'pointer'}}
            onClick={onDeleteIconClicked}
        />
    ];

    return (
        <>
            <StyledHeader>{t('manageDeviceTitle')}<Button type='primary' dense={true} style={{ margin: 0 }}>{t('downloadList')}</Button></StyledHeader>
            <ContentWrapper style={{ minWidth: '1020px'}}>
                <Header>
                    {t('allDevice')}
                    <ButtonContainer style={{visibility: selectedItems.length === 0 ? 'hidden' : 'visible', opacity: selectedItems.length === 0 ? '0' : '1'}}>
                        <Button type='primary' dense={true} style={buttonStyle} onClick={onPrintClicked}>{t('printBadge')}</Button>
                        <Button type='primary' dense={true} style={buttonStyle}>{t('edit')}</Button>
                        <Button type='primary' dense={true} style={buttonStyle} onClick={onDeleteClicked}>{t('delete')}</Button>
                    </ButtonContainer>
                    <SearchContainer>
                        <Search placeholder= {t('startTypingPlaceholder')} style={searchStyle}/>
                    </SearchContainer>
                </Header>
                <MainContent>
                    <Table 
                        defaultHeaders={tableHeaders} 
                        checkbox={true} 
                        defaultData={sampleData} 
                        pageSize={1}
                        pages={false}
                        rowActions={tableActions} 
                        // onSelectedChanged={(items) => setSelectedItems(items)}
                        // onRowHovered={(e, index) => setHoveredItem(index)}
                        showSort={false} //enable when sort is functional
                    />   
                </MainContent>       
            </ContentWrapper>
        </>
    )
}
